export default __webpack_public_path__ + "static/nature-11ee8c8a1ee5d18235a0af185ce6ffdf.jpg";